<script setup lang="ts">
import { cn } from "@voltalis/frontend-utils";

import CalendarIcon from "@/assets/icons/programs/calendar.svg?component";
import ShieldIcon from "@/assets/icons/shield.svg?component";
import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";
import { ProgramColorName } from "@/domains/v4b/program/program.types";
import { PROGRAM_COLORS } from "@/utils/programs/program-utils";

interface IProps {
  isSiteDefault?: boolean;
  size?: "small" | "regular";
  programColor: ProgramColorName;
}

const props = withDefaults(defineProps<IProps>(), {
  size: "regular",
});
</script>

<template>
  <span
    :class="
      cn(
        'flex size-[38px] shrink-0 items-center justify-center rounded-lg transition-all delay-700 bg-gradient-to-br',
        isSiteDefault
          ? 'default-program-icon'
          : [PROGRAM_COLORS[props.programColor].fromColor, PROGRAM_COLORS[props.programColor].toColor],
        {
          'w-[26px] h-[26px]': size === 'small',
        },
      )
    "
    :data-test-id="DATA_TEST_IDS.components.programIcon.component"
    :data-program-color="props.programColor"
  >
    <ShieldIcon v-if="props.isSiteDefault" />
    <CalendarIcon
      v-else
      :class="cn('size-[18px] text-white', { 'w-[14px] h-[14px]': size === 'small' })"
      :data-test-id="DATA_TEST_IDS.components.programIcon.calendarIcon"
    />
  </span>
</template>

<style lang="scss" scoped>
.default-program-icon {
  background-color: #d4d4dd;
  background-image: repeating-linear-gradient(
    135deg,
    rgba(61, 61, 77, 0.18) 0,
    rgba(61, 61, 77, 0.18) 1px,
    transparent 1px,
    transparent 6px
  );
}
</style>
